import { Link } from "react-router-dom";
import DocNavigation from "../../components/DocNavigation";

export default function SystemArchitecture() {
    return (
        <div className="space-y-16">

            {/* COMMON HERO */}
            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-4">
                    System Architecture
                </h1>
                <p className="text-md text-slate-600 max-w-3xl">
                    EventFlow is built on a modern, scalable, and secure architecture
                    designed to support real-world banquet operations with reliability.
                </p>
            </section>

            {/* HIGH LEVEL */}
            <section className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <div className="bg-[#C9A24E]/10 rounded-xl p-8">
                    <h2 className="text-xl font-semibold mb-4">
                        High-Level Architecture
                    </h2>
                    <p className="text-slate-700 mb-4">
                        EventFlow follows a clean three-layer architecture where each layer
                        is responsible for a specific role.
                    </p>
                    <ul className="space-y-2 text-slate-700">
                        <li>• Presentation Layer (Frontend)</li>
                        <li>• Application Layer (Backend)</li>
                        <li>• Data Layer (Database)</li>
                    </ul>
                </div>

                <div className="bg-white border border-slate-200 rounded-xl p-8">
                    <h3 className="text-lg font-semibold mb-4">
                        Why This Architecture?
                    </h3>
                    <ul className="space-y-2 text-slate-600">
                        <li>• Easier maintenance and upgrades</li>
                        <li>• Better performance under load</li>
                        <li>• Secure and controlled data flow</li>
                        <li>• Ready for future integrations</li>
                    </ul>
                </div>
            </section>

            {/* FLOW */}
            {/* FLOW */}
            <section className="bg-slate-100 rounded-xl p-10">
                <h2 className="text-xl font-semibold mb-6">
                    Logical Architecture Flow
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">

                    {/* FRONTEND */}
                    <div className="bg-white border rounded-lg p-6">
                        <h4 className="font-semibold mb-3">Frontend</h4>

                        {/* Logos */}
                        <div className="flex justify-center items-center gap-4 mb-4">
                            <img
                                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg"
                                alt="HTML5"
                                className="h-8"
                            />
                            <img
                                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg"
                                alt="CSS3"
                                className="h-8"
                            />
                            <img
                                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg"
                                alt="Bootstrap 5"
                                className="h-8"
                            />
                        </div>

                        <p className="text-sm text-slate-600">
                            Responsive user interface built using HTML, CSS, and Bootstrap 5,
                            ensuring smooth user experience across devices.
                        </p>
                    </div>

                    {/* BACKEND */}
                    <div className="bg-white border rounded-lg p-6">
                        <h4 className="font-semibold mb-3">Backend</h4>

                        {/* Logo */}
                        <div className="flex justify-center mb-4">
                            <img
                                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/laravel/laravel-original.svg"
                                alt="Laravel"
                                className="h-9"
                            />
                        </div>

                        <p className="text-sm text-slate-600">
                            Laravel handles business logic, validations, workflows,
                            authentication, and API-driven communication.
                        </p>
                    </div>

                    {/* DATABASE */}
                    <div className="bg-white border rounded-lg p-6">
                        <h4 className="font-semibold mb-3">Database</h4>

                        {/* Logo */}
                        <div className="flex justify-center mb-4">
                            <img
                                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg"
                                alt="MySQL"
                                className="h-9"
                            />
                        </div>

                        <p className="text-sm text-slate-600">
                            MySQL stores all operational, financial, booking,
                            and reporting data in a structured relational format.
                        </p>
                    </div>

                </div>
            </section>


            {/* BACKEND */}
            <section>
                <h2 className="text-xl font-semibold mb-6">
                    Backend Architecture (Laravel)
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {[
                        ["API-Driven Design", "All core features are exposed via REST APIs."],
                        ["Business Logic", "Booking rules, payments, and validations are centralized."],
                        ["Authentication", "Role-based access ensures controlled permissions."],
                        ["Security", "Server-side validation protects sensitive data."],
                    ].map(([title, desc], i) => (
                        <div key={i} className="bg-white border rounded-lg p-6">
                            <h4 className="font-semibold mb-2">{title}</h4>
                            <p className="text-sm text-slate-600">{desc}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* DATABASE */}
            <section className="bg-slate-100 rounded-xl p-10">
                <h2 className="text-xl font-semibold mb-6">
                    Database Layer (MySQL)
                </h2>
                <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 text-slate-700">
                    <li>• Centralized booking records</li>
                    <li>• Payment & advance tracking</li>
                    <li>• Supplier & expense management</li>
                    <li>• User & role management</li>
                    <li>• Historical data & reports</li>
                    <li>• Optimized relational structure</li>
                </ul>
            </section>

            {/* NEXT */}
            {/* <section className="border-t pt-8 mt-12">
                <p className="text-slate-600">
                    Next, explore the{" "}
                    <Link to="/docs/tech-stack" className="font-medium text-[#C9A24E]">
                        Tech Stack
                    </Link>{" "}
                    used to build EventFlow.
                </p>
            </section> */}
                 <DocNavigation
                previous={{
                    title: "Overview",
                    link: "/docs/overview"
                }}
                next={{
                    title: "Tech Stack",
                    link: "/docs/tech-stack"
                }}
            />
        </div>
    );
}


